import styled, { ITheme } from '../../../theme'

const Label2 = styled.div`
  font-size: 14px;
  margin-top: 30px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
`

export default Label2
